/**
 * A validator for leaflets LatLngBounds to be used with React prop types
 */
import * as L from 'leaflet';
import instanceValidator from '../utils/createInstanceValidator';

export default { ...instanceValidator(L.LatLngBounds, 'LatLng') };